import React, { useState } from "react";
import about from "../../assets/image/about_nha_pg_logo.png";
import { EncryptServices, MobileOTPServices } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { setMobileNumber, setUuid } from "../../redux/slices/abhaSlice";
import qrcode from "../../assets/image/qrcode.png";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";

/* ── Inline styles injected once ── */
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');

  /* ── Section wrapper ── */
  .lmop-section {
    font-family: 'Manrope', sans-serif;
    background: #0b0e17;
    padding: 60px 0 80px;
   
  }

  /* ── LEFT — Create steps ── */
  .lmop-left-title {
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 800;
    color: #fff;
    margin-bottom: 14px;
  }
  .lmop-left-desc {
    font-size: 0.9rem;
    color: #fff;
    line-height: 1.7;
    margin-bottom: 36px;
    max-width: 5;
  }
  .lmop-left-desc .highlight {
    font-weight: 700;
    color: #fff;
  }

  /* Vertical steps */
  .lmop-steps {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .lmop-step-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    position: relative;
    z-index: 1;
  }

  /* Orange circle marker using uploaded image */
  .lmop-step-marker {
    flex-shrink: 0;
    width: 56px;
    height: 56px;
    position: relative;
  }
  .lmop-step-marker img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .lmop-step-body {
    padding-top: 6px;
    padding-bottom: 28px;
  }
  .lmop-step-body h4 {
    font-size: 1rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 6px;
  }
  .lmop-step-body p {
    font-size: 0.82rem;
    color: #fff;
    line-height: 1.65;
    margin: 0;
    max-width: 320px;
  }
 

  /* ── RIGHT — Form card ── */
  .lmop-card-wrap {
    position: relative;
    padding: 20px;                  /* border thickness */
    border-radius: 22px;
    background: linear-gradient(180deg, #1a7fff 0%, #0033a0 50%, #000 100%);
    box-shadow: 0 0 60px rgba(26,127,255,0.25);
  }
  /* Optional: use uploaded bg image as the outer gradient */
  .lmop-card-wrap.use-img-bg {
    background-image: url(''); /* set via inline style from prop */
    background-size: cover;
    background-position: center;
  }
  .lmop-card-inner {
    background: #fff;
    border-radius: 18px;
    padding: 10px 25px 13px; 
     }

  .lmop-card-title {
    font-size: 1.55rem;
    font-weight: 800;
    color: #111;
    text-align: center;
    margin-bottom: 4px;
  }
  .lmop-card-subtitle {
    font-size: 0.82rem;
    color: #888;
    text-align: center;
    margin-bottom: 28px;
    font-weight: 500;
  }

  /* Mobile input */
  .lmop-mobile-input {
    width: 100%;
    background: #f5f6f8;
    border: 1px solid #e2e5ec;
    border-radius: 10px;
    padding: 14px 18px;
    font-size: 0.9rem;
    font-family: 'Manrope', sans-serif;
    color: #222;
    outline: none;
    transition: border 0.2s, box-shadow 0.2s;
    margin-bottom: 6px;
  }
  .lmop-mobile-input:focus {
    border-color: #1a7fff;
    box-shadow: 0 0 0 3px rgba(26,127,255,0.12);
  }
  .lmop-mobile-input::placeholder { color: #aab; }

  /* OR divider */
  .lmop-or {
    text-align: center;
    font-size: 0.85rem;
    font-weight: 600;
    color: #555;
    margin: 14px 0;
  }

  /* Scan QR button — orange */
  .lmop-qr-btn {
    display: block;
    width: 100%;
    background: linear-gradient(90deg, #e85d04 0%, #f77f00 100%);
    color: #fff;
    font-family: 'Manrope', sans-serif;
    font-size: 0.95rem;
    font-weight: 700;
    padding: 15px;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    text-align: center;
    transition: opacity 0.2s, transform 0.15s;
    margin-bottom: 14px;
  }
  .lmop-qr-btn:hover { opacity: 0.9; transform: translateY(-1px); }

  /* Continue button — blue */
  .lmop-continue-btn {
    display: block;
    width: 100%;
    background: linear-gradient(90deg, #1a7fff 0%, #0058e0 100%);
    color: #fff;
    font-family: 'Manrope', sans-serif;
    font-size: 0.95rem;
    font-weight: 700;
    padding: 15px;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    text-align: center;
    transition: opacity 0.2s, transform 0.15s;
    margin-top: 6px;
  }
  .lmop-continue-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
  .lmop-continue-btn:disabled,
  .lmop-continue-btn.bg-disable {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }

  /* NHA logo row */
  .lmop-nha-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
   
    padding-top: 18px;
    border-top: 1px solid #eee;
  }
  .lmop-nha-label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 1px;
    color: #999;
    text-transform: uppercase;
  }
  .lmop-nha-logo {
    height: 36px;
    object-fit: contain;
  }

  /* Error / info messages */
  .lmop-msg-err { color: #cf1f1f; font-size: 0.8rem; margin-top: 4px; }
  .lmop-msg-ok  { color: #1a7fff; font-size: 0.8rem; margin-top: 4px; }

  /* QR Modal */
  .lmop-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }
  .lmop-modal-box {
    background: #fff;
    border-radius: 16px;
    padding: 32px 28px;
    max-width: 380px;
    width: 90%;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0,0,0,0.4);
  }
  .lmop-modal-box h5 {
    font-size: 1.1rem;
    font-weight: 700;
    margin-bottom: 20px;
    color: #111;
  }
  .lmop-modal-box img {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    border-radius: 8px;
  }
  .lmop-modal-close {
    background: #555;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 10px 28px;
    font-family: 'Manrope', sans-serif;
    font-weight: 600;
    cursor: pointer;
  }

  /* Responsive */
  @media (max-width: 767px) {
    .lmop-section { padding: 40px 0 60px; }
    .lmop-card-inner { padding: 28px 20px 24px; }
    .lmop-step-body { padding-bottom: 20px; }
    .lmop-left-title { margin-bottom: 10px; }
  }
`;

/* Inject CSS once */
if (typeof document !== "undefined" && !document.getElementById("lmop-styles")) {
  const tag = document.createElement("style");
  tag.id = "lmop-styles";
  tag.innerHTML = css;
  document.head.appendChild(tag);
}

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const LoginMobileOTPSend = ({
  setIsVerified,
  setMobileOTPSent,
  setIsVerifiedOtp,
  setCurrentStep,
}) => {
  const [mobile, setMobile] = useState("");
  const [patientdetail, setPatientdetail] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpGuid, setOtpGuid] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [showQrModal, setShowQrModal] = useState(false);
  const dispatch = useDispatch();

  const mobileLength = mobile.length > 9;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedMobile = mobile.trim();
    if (/^[6-9]\d{9}$/.test(trimmedMobile)) {
      sendOtp();
      setMsg("");
    } else {
      setMsg("Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.");
    }
  };

  const sendOtp = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const emobile = await EncryptServices({ headers: {}, body: { data: mobile } });
      dispatch(setMobileNumber(mobile));
      localStorage.setItem("mobile", mobile);
      localStorage.setItem("patientdetail", patientdetail);
      const response = await MobileOTPServices({ body: { mobile: emobile } });
      if (response?.success) {
        if (response.data?.otpGuid) {
          const otpData = response.data;
          dispatch(setUuid(otpData.otpGuid));
          if (otpData?.otpGuid) {
            setOtpGuid(otpData.otpGuid);
            localStorage.setItem("otpResponse", JSON.stringify(response));
            setOtp(["", "", "", "", "", ""]);
            toast.success("OTP sent successfully!");
            setCurrentStep("LoginMobileOtpVerify");
          } else {
            toast.error("OTP sent but technical error occurred");
            localStorage.removeItem("otpResponse");
          }
        } else {
          toast.error(response.message || "Failed to send OTP");
          if (!response.status) {
            setOtpGuid("");
            localStorage.removeItem("otpResponse");
          }
        }
      } else {
        toast.error(response?.message || "Failed to send OTP");
        return response;
      }
    } catch (error) {
      toast.error("Failed to send OTP. Please try again.");
      localStorage.removeItem("otpResponse");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* ── Inject styles ── */}
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>
          <div className="row align-items-start g-4 g-lg-5 ">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">

              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: Login Form ── */}
            <div className="col-12 col-md-6">
              {/* Blue gradient border card using uploaded Group_2147206200.png as bg */}
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">Login</h3>
                  <p className="lmop-card-subtitle">Verify with your mobile Number</p>

                  <form onSubmit={handleSubmit}>
                    <input
                      type="tel"
                      maxLength={10}
                      pattern="[6-9]{1}[0-9]{9}"
                      placeholder="Enter Mobile Number"
                      value={mobile}
                      autoComplete="off"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setMobile(value);
                      }}
                      className="lmop-mobile-input"
                    />

                    {msg && <p className="lmop-msg-err">{msg}</p>}
                    {error && (
                      <p className={error.includes("successfully") ? "lmop-msg-ok" : "lmop-msg-err"}>
                        {error}
                      </p>
                    )}

                    <p className="lmop-or">Or</p>

                    <button
                      type="button"
                      className="lmop-qr-btn"
                      onClick={() => setShowQrModal(true)}
                    >
                      Scan QR to Link &amp; Register
                    </button>

                    <button
                      type="submit"
                      className={`lmop-continue-btn ${!mobileLength || isLoading ? "bg-disable" : ""}`}
                      disabled={!mobileLength || isLoading}
                    >
                      {isLoading ? "Sending OTP..." : "Continue"}
                    </button>
                  </form>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── QR Modal ── */}
      {showQrModal && (
        <div className="lmop-modal-overlay" onClick={() => setShowQrModal(false)}>
          <div className="lmop-modal-box" onClick={(e) => e.stopPropagation()}>
            <h5>Scan this QR Code</h5>
            <img src={qrcode} alt="QR Code" />
            <button className="lmop-modal-close" onClick={() => setShowQrModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginMobileOTPSend;
